module.exports = __webpack_public_path__ + "img/Service_advantage@2x.34b4d7bd.png";